var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"card px-0",attrs:{"border-variant":"light"}},[_c('b-card-text',[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.data),function(amount,currencyCode){return _c('span',{key:currencyCode,staticClass:"chip"},[_vm._v("\n      "+_vm._s(amount)+" "+_vm._s(currencyCode)+"\n    ")])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }